const state = {
  aiEvents: {},
};

const getters = {
  all: (state) => Object.values(state.aiEvents),
  get: (state) => state.aiEvents,
  miraEnabled: (state) => {
    return Object.values(state.aiEvents).some(event =>
      event.eventType === 'front_end_user_event' &&
      event.enabled === true,
    );
  },
  miraVisible: (state) => {
    return Object.values(state.aiEvents).some(event =>
      event.eventType === 'front_end_user_event' &&
      event.visible === true,
    );
  },
  shortcutEvents: (state) => {
    return Object.values(state.aiEvents).filter(event =>
      event.eventType === 'shortcut_event',
    );
  },
  shortcutEventsByContext: (state) => (context) => {
    return Object.values(state.aiEvents).filter(event =>
      event.eventType === 'shortcut_event' &&
      event.context === context,
    );
  },
  frontEndUserEventId: (state) => {
    const event = Object.values(state.aiEvents).find(event =>
      event.eventType === 'front_end_user_event',
    );
    return event ? event.id : null;
  },
};

const mutations = {
  set: function(state, aiEvents = []) {
    state.aiEvents = {};
    aiEvents.forEach(event => {
      state.aiEvents[event.id] = event;
    });
  },
};

const actions = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
